export default [
  {
    path: '/',
    permissions: ['MASTER', 'ADMINISTRADOR', 'CREDENCIADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  }, /*
  {
    path: '/newsletter',
    permissions: ['MASTER', 'ADMINISTRADOR', 'CREDENCIADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  }, */
  {
    path: '/dashboard',
    permissions: ['MASTER', 'ADMINISTRADOR', 'CREDENCIADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  },
  {
    path: '/monitoring-legacy',
    permissions: ['MASTER', 'ADMINISTRADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  },
  {
    path: '/monitoring-cockpit',
    permissions: ['MASTER', 'ADMINISTRADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  },
  {
    path: '/consulta-apis',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/job-envia-dados-rest',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/job-envia-dados-soap',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/rest-to-soap',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/workflow',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/cadastro-db',
    permissions: ['MASTER', 'ADMINISTRADOR']
  },
  {
    path: '/credentials',
    permissions: ['MASTER', 'CREDENCIADOR']
  },
  {
    path: '/from-to',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/parameter',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/sequence',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/socket-server',
    permissions: ['MASTER', 'ADMINISTRADOR']
  },
  {
    path: '/emailserver',
    permissions: ['MASTER', 'ADMINISTRADOR']
  },
  {
    path: '/user',
    permissions: ['MASTER', 'ADMINISTRADOR', 'CREDENCIADOR', 'DESENVOLVEDOR', 'MONITORADOR']
  },
  {
    path: '/truststore',
    permissions: ['MASTER']
  },
  {
    path: '/parameter',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/sequence',
    permissions: ['MASTER', 'DESENVOLVEDOR']
  },
  {
    path: '/socket-server',
    permissions: ['MASTER', 'ADMINISTRADOR']
  },
  {
    path: '/emailserver',
    permissions: ['MASTER', 'ADMINISTRADOR']
  },
  {
    path: '/select-client',
    permissions: ['MASTER', 'MULTI_TENANT', 'DESENVOLVEDOR', 'ADMINISTRADOR', 'CREDENCIADOR', 'MONITORADOR']
  },
  {
    path: '/logout',
    permissions: ['MASTER', 'ADMINISTRADOR', 'CREDENCIADOR', 'DESENVOLVEDOR', 'MONITORADOR', 'MULTI_TENANT']
  },
  {
    path: '/client',
    permissions: ['MASTER']
  }
]
